import axios from "axios";
import router from "@/router";

const ENDPOINT = process.env.VUE_APP_ENDPOINT;

const dealer = {
  namespaced: true,

  state: {
    alleson_id: null,
    campaigns: [],
    can_order: 0,
    carriedt: null,
    carrier_num: null,
    checkout_type: "",
    class_name: null,
    colors: [],
    customers: {},
    email: "",
    fsg_code: "",
    header_color: "",
    header_message: "",
    id: "",
    logo: "",
    logo_content:"",
    name: "",
    omg_account_number: "",
    passcode: "",
    phone: "",
    price_group: "",
    reps: [],
    request_quote: "",
    rhino_code: "",
    settings: {},
    webUserId: null,
    dealerMargin: 2
  },

  getters: {
    getAllColors: (state) => {
      return state.colors;
    },

    getColorById: (state) => (id) => {
      for (let index = 0; index < state.colors.length; index++) {
        const color = state.colors[index];
        if (Number(color.id) === Number(id)) {
          return color;
        }
      }
      return false;
    },
    getColorByName: (state) => (colorName) => {
      for (let index = 0; index < state.colors.length; index++) {
        const color = state.colors[index];
        if (color.name === colorName) {
          return color;
        }
      }
      return false;
    },

    getColorHex: (_state, getters) => (id) => {
      const color = getters.getColorById(id);
      return color && color.hex;
    },

    getColorName: (_state, getters) => (id) => {
      const color = getters.getColorById(id);
      return color && color.name;
    },

    getAllSports: (state) => {
      return state.catalogs;
    },

    getRepByName: (state) => (name) => {
      const filteredRep = state.reps?.filter((rep) => rep?.name === name);

      return filteredRep.length ? filteredRep[0] : { id: null };
    },

    getRepById: (state) => (id) => {
      const filteredRep = state.reps?.filter((rep) => rep?.id === id);

      return filteredRep && filteredRep.length ? filteredRep[0] : { id: null };
    },

    getCustomerById: (state) => (id) => {
      const customer = state.customers.filter((customer) => customer.id === id);

      return customer.length ? customer[0] : {};
    },

    rhinoCode: (state) => state.rhino_code,
  },

  actions: {
    // Get dealer data in the
    async getFullDealerDataOrCreateItInDashboard(
      { rootState, commit, dispatch },
      data
    ) {
      const { token, accountid } = data;

      // if (this.$router.currentRoute.name === "Forbidden") return false; //Ask fran where this should be implemented
      let tokenUrl;
      let formData = new FormData();
      let { rep_token, web_user_id } = data;
      console.log({ web_user_id });
      //Impersonation from FSG Rep Access
      if (rep_token) {
        tokenUrl = ENDPOINT + "/api/fsg/me?api_token=" + rep_token;
      } else {
        //Normal Login, check if the enviroment is dev or production
        tokenUrl = rootState.settings.validateGamePlanToken
          ? rootState.settings.fsajax
          : ENDPOINT + "/api/v2/is-alive";
      }

      formData.append("F", "ValidateGamePlanToken");
      formData.append("token", token?.split(" ").join("+"));
      formData.append("acid", accountid);

      try {
        const GPResponse = rep_token
          ? await axios.get(tokenUrl, formData)
          : await axios.post(tokenUrl, formData);

        if (
          !rootState.settings.validateGamePlanToken ||
          (GPResponse.data &&
            GPResponse.data.Success &&
            GPResponse.data.IsValid)
        ) {
          axios
            .get(ENDPOINT + "api/v2/dealer", {
              params: {
                code: accountid,
                token,
              },
            })
            .then((resp) => {
              dispatch("auth/setAuthorizedToUseDashboard", true, {
                root: true,
              });
              dispatch("auth/setApiToken", resp.data.api_token, { root: true });
              dispatch("auth/setDealerMode", true, { root: true });
              commit("SET_DEALER", resp.data);
              commit("SET_WEB_USER_ID", web_user_id);
            })
            .catch((error) => {
              if (error.response.status === 400) {
                //create dealer from params
                axios
                  .post(ENDPOINT + "api/v2/dealer", data.postData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then(() => {
                    axios //try again getting the newly registered dealer - because it does not return in the previous call (todo ask digi to return it in the backend)
                      .get(ENDPOINT + "api/v2/dealer", {
                        params: {
                          code: data.accountid,
                        },
                      })
                      .then((datap) => {
                        //we already have dealer info registered
                        dispatch("auth/setAuthorizedToUseDashboard", true, {
                          root: true,
                        });
                        dispatch("auth/setApiToken", datap.data.api_token, {
                          root: true,
                        });
                        dispatch("auth/setDealerMode", true, { root: true });
                        commit("SET_DEALER", datap.data);
                      })
                      .catch(() => {
                        dispatch(
                          "showToast",
                          {
                            txt: "Error",
                            type: "error",
                          },
                          { root: true }
                        );
                      });
                  })
                  .catch(() => {
                    dispatch(
                      "showToast",
                      {
                        txt: "Error",
                        type: "error",
                      },
                      { root: true }
                    );
                  });
              }
            });

          //update and set Dealer data
          //commit("SET_DEALER", endpointResponse.data);
        } else {
          dispatch(
            "showToast",
            {
              txt: "Error",
              type: "error",
            },
            { root: true }
          );
        }
      } catch (error) {
        return new Error(error);
      }
    },

    // Get dealer data in projects
    async getDealerInProject({ rootState, dispatch, commit }, passcode) {
      //Check if the session existes in the Storage Session, and if it belongs to the snapsheet's dealer
      if (await dispatch("auth/checkIfSessionExists", null, { root: true })) {
        const sessionData = await dispatch("auth/getSessionData", null, {
          root: true,
        });
        commit("SET_DEALER", sessionData);
        dispatch("auth/setApiToken", sessionData.api_token, { root: true });
        commit("auth/SET_DEALER_MODE", sessionData.api_token, { root: true });
      } else {
        //Else, login with the url or login modal params
        try {
          const { data } = await axios.get(
            ENDPOINT + "api/v2/projects/dealer",
            {
              params: {
                passcode: passcode || router.currentRoute.query.passcode,
                code: router.currentRoute.params.dealer_code,
                project_id: router.currentRoute.params.project_id,
                project_type: rootState.project.typeOfProject,
              },
            }
          );

          data["rhino_code"] = router.currentRoute.params.dealer_code;
          commit("SET_DEALER", data);

          const token = data.api_token;

          //set session storage
          if (token) {
            await dispatch("auth/saveSessionData", data, { root: true });
            dispatch("auth/setApiToken", token, { root: true });
            commit("auth/SET_DEALER_MODE", true, { root: true });
          }
        } catch (error) {
          console.log(error);
          throw new Error("error loading dealer data");
        }
      }
    },

    async updateDealer({ rootState, commit, dispatch }, formData) {
      console.log({formData});
      formData.append("_method", "put");
      await axios({
        method: "POST",
        url: ENDPOINT + "api/v2/dealer",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      })
        .then((response) => {
          dispatch(
            "showToast",
            {
              txt: "Information updated.",
            },
            { root: true }
          );
          console.log("response.data", response.data);
          commit("updateDealer", response.data);
        })
        .catch((e) => {
          dispatch(
            "showToast",
            {
              txt: e,
              type: "error",
            },
            { root: true }
          );
        });
    },
    async deleteDealerLogo({ state, rootState, commit, dispatch }) {
      await axios({
        method: "PUT",
        url: ENDPOINT + "api/v2/dealer/clear-logo",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      })
        .then(() => {
          dispatch(
            "showToast",
            {
              txt: "Information updated.",
            },
            { root: true }
          );
          commit("updateDealer", { ...state, logo: null, logo_id: null });
        })
        .catch((e) => {
          dispatch(
            "showToast",
            {
              txt: e,
              type: "error",
            },
            { root: true }
          );
        });
    },

    async getAllReps({ rootState, dispatch }) {
      try {
        const { data } = await axios.get(ENDPOINT + "api/v2/reps", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        });
        dispatch("setAllReps", data);
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: error,
            type: "error",
          },
          { root: true }
        );
      }
    },

    setAllReps({ commit }, reps) {
      commit("SET_ALL_REPS", reps);
    },

    async addNewSalesRep({ rootState, commit, dispatch }, params) {
      await axios
        .post(ENDPOINT + "api/v2/rep", params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        })
        .then(({ data }) => {
          dispatch(
            "showToast",
            {
              txt: '"' + params.name + '" added successfully.',
            },
            { root: true }
          );
          commit("setNewSalesRep", data);
        })
        .catch((e) => {
          dispatch(
            "showToast",
            {
              txt: e,
              type: "error",
            },
            { root: true }
          );
        })
        .finally(
          document.getElementById("closeRepModal") &&
            document.getElementById("closeRepModal").click()
        );
    },

    postRepsModal({ rootState, commit, dispatch }, data) {
      let params = {
        name: data.modalName,
        email: data.modalEmail,
        phone: data.modalPhone,
        _method: "post",
      };
      if (data.modalUserId) {
        params.user_id = data.modalUserId;
        params._method = "put";
      }
      document.getElementById("closeRepModal").click();
      axios
        .post(this.state.settings.endpoint + "api/v2/rep", params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        })
        .then((response) => {
          if (data.modalUserId) {
            dispatch("showToast", {
              txt: '"' + data.modalName + '" edited successfully.',
            });
            commit("editSalesRep", params);
          } else {
            dispatch("showToast", {
              txt: '"' + data.modalName + '" added successfully.',
            });
            commit("addSalesRep", response.data);
          }
        })
        .catch((e) => {
          dispatch("showToast", {
            txt: e,
            type: "error",
          });
        });
    },

    async editSalesRep({ rootState, commit, dispatch }, params) {
      await axios
        .post(ENDPOINT + "api/v2/rep", params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        })
        .then(() => {
          dispatch(
            "showToast",
            {
              txt: '"' + params.name + '" edited successfully.',
            },
            { root: true }
          );
          commit("updateSalesRep", params);
        })
        .catch((e) => {
          dispatch(
            "showToast",
            {
              txt: e,
              type: "error",
            },
            { root: true }
          );
        })
        .finally(document.getElementById("closeRepModal").click());
    },

    async removeSalesRep({ rootState, commit, dispatch }, rep) {
      await axios
        .delete(ENDPOINT + "api/v2/rep", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
          data: {
            user_id: rep.id,
          },
        })
        .then(() => {
          dispatch(
            "showToast",
            {
              txt: '"' + rep.name + '" removed',
            },
            { root: true }
          );
          commit("deleteSalesRep", rep.id);
        })
        .catch((error) => {
          if (error.response) {
            dispatch(
              "showToast",
              {
                txt: error.response.data,
                type: "error",
              },
              { root: true }
            );
          } else {
            dispatch(
              "showToast",
              {
                txt: error,
                type: "error",
              },
              { root: true }
            );
          }
        });
    },

    addTeamLink({ commit }, link) {
      commit("addTeamLink", link);
    },
  },

  mutations: {
    addTeamLink: (state, link) => {
      state.teamlinks.push(link);
    },

    SET_DEALER: (state, data) => {
      state.alleson_id = data.alleson_id;
      state.campaigns = data.campaigns;
      state.can_order = data.can_order;
      state.carriedt = data.carriedt;
      state.carrier_num = data.carrier_num;
      state.checkout_type = data.checkout_type;
      state.class_name = data.class_name;
      state.colors = data.colors;
      state.customers = data.customers;
      state.email = data.email;
      state.fsg_code = data.fsg_code;
      state.header_color = data.header_color;
      state.header_message = data.header_message;
      state.id = data.id;
      state.logo = data.logo;
      state.logo_id = data.logo_id;
      state.name = data.name;
      state.omg_account_number = data.omg_account_number;
      state.passcode = data.passcode;
      state.phone = data.phone;
      state.price_group = data.price_group;
      state.request_quote = data.request_quote;
      state.rhino_code = data.rhino_code;
      state.settings = data.settings;
      state.dealerMargin = data.dealerMargin || 2;

      //Fix - when the dealer tries to login and input the wrong passcode, do not set the reps
      if (data.reps) {
        state.reps = data.reps;
      }
    },

    SET_WEB_USER_ID: (state, webUserId) => (state.webUserId = webUserId),

    updateDealer: (state, data) => {
      if (!state.settings) state.settings = {};
      Object.assign(state.settings, data.settings);
      state.logo = data.logo;
      state.logo_id = data.logo_id;
      state.logo_content = data.logo_content;
      state.passcode = data.passcode;
    },

    setAccountNumber: (state, data) => {
      state.omg_account_number = data.omgAccountNumber;
    },

    setTeamLink: (state, link) => {
      state.teamlinks.push(link);
    },

    SET_ALL_REPS: (state, data) => {
      state.reps = data;
    },

    setNewSalesRep: (state, rep) => {
      state.reps.push(rep);
    },

    updateSalesRep: (state, params) => {
      for (let index = 0; index < state.reps.length; index++) {
        const element = state.reps[index];
        if (element.id === params.user_id) {
          state.reps[index].name = params.name;
          state.reps[index].email = params.email;
          state.reps[index].phone = params.phone;
          break;
        }
      }
    },

    deleteSalesRep: (state, repId) => {
      for (let index = 0; index < state.reps.length; index++) {
        const element = state.reps[index];
        if (element.id === repId) {
          state.reps.splice(index, 1);
          break;
        }
      }
    },

    setNewCustomer: (state, newCustomer) => {
      state.customers.push(newCustomer);
    },
  },
};

export default dealer;
